module.exports = __webpack_public_path__ + "media/img/event/speakers/ann-marie-headshot-d481b97308c789b7461d8677362abd11.jpg";